import React from 'react';
import style from '../orderItemDetail.module.scss';
import cn from 'classnames';

const DESCRIPTION_TEXT_STYLE = {
  fontSize: '14px',
  lineHeight: '1.4em',
  maxHeight: '5.6em',
  overflowY: 'auto'
};

const DescriptionSection = React.memo(({ name, description }) => (
  <div className={cn(style.itemText, 'pl-2')}>
    <div id="itemName" className="my-2">
      <div className="fw-600 fs_20">{name || ''}</div>
    </div>
    {description ? (
      <div className="my-2" style={DESCRIPTION_TEXT_STYLE}>{description}</div>
    ) : (
      <div className="my-2" style={DESCRIPTION_TEXT_STYLE}>&nbsp;</div>
    )}
  </div>
));

export default DescriptionSection;
